import { render, staticRenderFns } from "./scene7.vue?vue&type=template&id=f49483b0&scoped=true&"
import script from "./scene7.vue?vue&type=script&lang=ts&"
export * from "./scene7.vue?vue&type=script&lang=ts&"
import style0 from "./scene7.vue?vue&type=style&index=0&id=f49483b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49483b0",
  null
  
)

export default component.exports